import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import LinkEditor from '../../../components/Editor/LinkEditor';
import { getPageEditableMediaIds } from '../selectors';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			editableLinks,
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
		},
	} = state;

	const { page, id } = ownProps;
	const editableMediaIds = getPageEditableMediaIds(state);

	return {
		value: editableLinks[page][id].href,
		isActive: id === activeItem.id,
		isEditPanelDisplayed,
		hasEditableImage: editableMediaIds.includes(id),
	};
};

export default connect(mapStateToProps)(LinkEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/LinkEditor/index.tsx